import React from 'react';
import { IIconProps } from './utils';

export const Rocket = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20.7534 18.0771C23.6926 15.1379 25.2124 10.7792 25.627 6.3256C25.732 5.1977 24.7995 4.26518 23.6716 4.37019C19.218 4.78483 14.8593 6.30457 11.9201 9.24379M20.7534 18.0771C18.7799 20.0506 16.6143 21.3424 14.4844 21.7249C14.1839 21.7788 13.8807 21.6696 13.6648 21.4537L8.54347 16.3323C8.32762 16.1165 8.21837 15.8133 8.27231 15.5128C8.65474 13.3829 9.94658 11.2173 11.9201 9.24379M20.7534 18.0771C22.0342 20.355 20.1931 23.7946 18.2808 26.1227C17.8918 26.5963 17.1648 26.5628 16.8676 26.0268C15.966 24.4012 15.8767 22.7217 16.241 21.2014M11.9201 9.24379C9.64223 7.96298 6.20261 9.80404 3.8745 11.7164C3.4009 12.1054 3.43437 12.8323 3.97036 13.1296C5.59601 14.0312 7.27549 14.1204 8.79577 13.7562"
      stroke={fill}
      strokeWidth="2.5"
    />
    <path
      d="M16.656 10.4142C17.4371 9.63317 18.7034 9.63317 19.4845 10.4142C20.2655 11.1953 20.2655 12.4616 19.4845 13.2426C18.7034 14.0237 17.4371 14.0237 16.656 13.2426"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M7.24219 20L5.24219 22" stroke={fill} strokeLinecap="round" strokeWidth="2.5" />
    <path d="M10.2422 23L6.24219 27" stroke={fill} strokeLinecap="round" strokeWidth="2.5" />
  </svg>
);
